import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { CopyToExcelButtonComponent } from '../../../../core/components/buttons/copy-to-excel/copy-to-excel-button.component';
import { LinkButtonComponent } from '../../../../core/components/buttons/link/link-button.component';
import { AG_GRID_DEFAULT_OPTIONS } from '../../../../core/config/aggrid.default.config';
import { FacturaGastoDtoOut } from '../../../models/gasto.model';
import { ContabilidadGastoService } from '../../../services/contabilidad-gasto.service';

@Component({
  selector: 'app-gasto-facturas-no-procesables',
  standalone: true,
  imports: [AgGridAngular, CommonModule, CopyToExcelButtonComponent],
  templateUrl: './gasto-facturas-no-procesables.component.html',
  styleUrl: './gasto-facturas-no-procesables.component.scss',
})
export class GastoFacturasNoProcesablesComponent implements OnInit {
  facturas: FacturaGastoDtoOut[] = [];

  isColumnDropdownOpen = false;
  gridApi!: GridApi;

  constructor(
    private readonly router: Router,
    private readonly gastosService: ContabilidadGastoService
  ) {}

  ngOnInit(): void {
    this.refreshGridColumns();
    this.obtenerFacturas();
  }

  obtenerFacturas(): void {
    this.gastosService.getFacturasNoProcesables().subscribe((facturas) => {
      this.facturas = facturas;
    });
  }

  gridOptions: GridOptions = {
    ...AG_GRID_DEFAULT_OPTIONS,
    onGridReady: (params) => (this.gridApi = params.api),
    onRowDoubleClicked: this.onRowDoubleClicked.bind(this),
  };
  columnDefs: ColDef[] = [];

  columnOptions = [
    { field: 'id', headerName: 'ID', selected: true },
    { field: 'proveedorNombre', headerName: 'Proveedor', selected: true },
    { field: 'codFactura', headerName: 'Numero', selected: true },
    { field: 'fechaEmision', headerName: 'FechaEmision', selected: true, filter: 'agDateColumnFilter' },
    { field: 'baseImponible', headerName: 'Base Imponible', selected: true },
    { field: 'importeTotal', headerName: 'Importe Total', selected: true },
    { field: 'numeroFacturaCompra', headerName: 'Numero Compra', selected: true },
    { field: 'fechaFacturaCompra', headerName: 'Fecha Compra', selected: true },
    { field: 'cuentaBancariaCompra', headerName: 'Cuenta Bancaria Compra', selected: true },
    { field: 'actions', label: 'Opciones', selected: true },
  ];

  toogleColumnDropdown(): void {
    this.isColumnDropdownOpen = !this.isColumnDropdownOpen;
  }

  toggleColumnaSeleccionada(option: any): void {
    option.selected = !option.selected;
    this.refreshGridColumns();
  }

  refreshGridColumns(): void {
    this.columnDefs = this.columnOptions.map((col) => {
      if (col.field === 'actions') {
        return {
          field: col.field,
          headerName: col.headerName,
          hide: this.isColumnahide(col.field),
          cellRenderer: LinkButtonComponent,
          cellRendererParams: (params: any) => ({
            link: `/facturas-suministros/${params.data.id}`,
          }),
          resizable: false,
          sortable: false,
          filter: false,
          suppressMovable: true,
        };
      }

      return {
        field: col.field,
        headerName: col.headerName,
        filter: col.filter,
        hide: this.isColumnahide(col.field),
      };
    });
  }

  isColumnahide(columna: string): boolean {
    const column = this.columnOptions.find((col) => col.field === columna);
    return !column?.selected;
  }

  onRowDoubleClicked({ data }: { data: FacturaGastoDtoOut }): void {
    const facturaId = data.id;
    this.router.navigate([`/facturas-suministros/${facturaId}`]);
  }
}
